import React from "react";
import { cn } from "../../lib/utils";
import type { ContentFrameProps } from "./types";

export function ContentFrame({
  children,
  layout = "canvas",
  aside,
  padded = true,
  className,
  bodyClassName,
  asideClassName,
}: ContentFrameProps) {
  return (
    <div
      className={cn(
        "flex h-full min-h-0 min-w-0 bg-background",
        className
      )}
    >
      {/* Main content body */}
      <div
        className={cn(
          "flex-1 min-w-0 h-full min-h-0",
          layout === "document" && "max-w-5xl mx-auto",
          padded && "p-6",
          bodyClassName
        )}
      >
        {children}
      </div>

      {/* Optional aside panel */}
      {aside && (
        <aside
          className={cn(
            "w-80 border-l border-border bg-card flex-shrink-0 sticky top-0 h-full",
            padded && "p-4",
            asideClassName
          )}
        >
          {aside}
        </aside>
      )}
    </div>
  );
}
